export enum ELocalStorage {
  ACCESS_TOKEN = "access_token",
  REFRESH_TOKEN = "refresh_token",
  EXPIRES_IN = "expires_in",
  REFRESH_EXPIRES_IN = "refresh_expires_in",
  FIRSTNAME = "firstName",
  LASTNAME = "lastName",
  USERNAME = "username",
  ROLE = "role",
  PERMISSIONS = "permissions",
  BLOCEKD_MENUS = "blocked_menus",
  LANGUAGE = "language",
  USER_ID = "user_id",
  USER = "user",
  LEVEL = "level",
  REGION_ID = "regionId",
  DISTRICT_ID = "districtId",
  COMPANY_ID = "companyId",
  MAHALLA_ID = "mahallaId",
  STREET_ID = "streetId",
  POLYGON_ID = "polygonId",
  VEHICLE_ID = "companyAutomobileId",
  IS_SUPER_ADMIN_INIT = "is_super_admin_init",
  IS_REGION_ADMIN_INIT = "is_region_admin_init",
  IS_DISTRICT_ADMIN_INIT = "is_district_admin_init",
  STEPPER_PARAMS = "STEPPER_PARAMS",
  ACT_PACK = "ACT_PACK",
  CURRENT_ZONE = "CURRENT_ZONE",
}

export enum THEME_MODE {
  LIGHT = "light",
  DARK = "dark",
  SYSTEM = "system",
}
